import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import { SettingsPermissionGuard } from './guards/settings-permission.guard';
import { TeamMembersPermissionGuard } from './guards/team-members-permission.guard';
import { SettingsDataBuilder } from './settings-data.builder';
import { SettingsDataDispatcher } from './settings-data.dispatcher';
import { SettingsDataEffects } from './settings-data.effects';
import { FEATURE_NAME, reducer } from './settings-data.reducer';
import { SettingsDataResolve } from './settings-data.resolve';
import { SettingsDataService } from './settings-data.service';
import { SettingsDataStore } from './settings-data.store';
import { RenewalInfoGuard } from './guards/renewal-info.guard';

export const settingsDataEffects = [SettingsDataEffects];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class SettingsDataModule {
  static forRoot(): ModuleWithProviders<SettingsDataModule> {
    return {
      ngModule: SettingsDataModule,
      providers: [
        SettingsDataStore,
        SettingsDataService,
        SettingsDataBuilder,
        SettingsDataDispatcher,
        SettingsDataResolve,
        SettingsPermissionGuard,
        TeamMembersPermissionGuard,
        RenewalInfoGuard,
      ],
    };
  }
}
